export const windowScrollTop = () => {
  window.scroll(0, 0);
};
